const E2E_MOCK_MODE_COOKIE = 'e2e-mock-mode'
const E2E_MOCK_FEATURE_COOKIE = 'e2e-mock-feature'

function readBrowserCookie(name) {
  if (typeof document === 'undefined') {
    return null
  }

  const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${escapedName}=([^;]*)`)
  )

  if (!match) {
    return null
  }

  return decodeURIComponent(match[1] || '')
}

export function getE2EMockMode() {
  return readBrowserCookie(E2E_MOCK_MODE_COOKIE)
}

export function getE2EMockFeature() {
  return readBrowserCookie(E2E_MOCK_FEATURE_COOKIE)
}
